let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fyS0J")).then(() => parcelRequire('45NuA'));